import React, {
  createContext,
  useState,
  useMemo,
  useCallback,
  useEffect
} from 'react';
import PropTypes from 'prop-types';

export const SimplotContext = createContext();

const Provider = ({ children = null }) => {
  const host = "https://qa.financials.cropwise.com" || 'http://localhost:3000';
  const redirect = `${host}/app/integrations/Simplot`;
  const clientId = "44ad8ad0-5abc-43e5-be3d-0934f00631be";

  const [step, setStep] = useState(1);
  const goBack = () => {
    setStep(s => Math.max(0, s - 1));
  };

  const goForward = () => {
    setStep(s => s + 1);
  };

  const simplotOauthUrl = `${undefined}`
    .replaceAll('{clientId}', clientId)
    .replaceAll('{redirect}', redirect);

  const redirectToSimplotAuthorizeOrgUrl = useCallback(() => {
    globalThis.location.href = `${undefined}`
      .replaceAll('{clientId}', clientId)
      .replaceAll('{redirect}', redirect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [canGoNext, setCanGoNext] = useState(false);
  const blockStepForward = () => setCanGoNext(false);
  const releaseStepForward = () => setCanGoNext(true);

  const selectPropertiesStep = 4;

  useEffect(() => {
    if (step === selectPropertiesStep) {
      setCanGoNext(true); // in properties selection there have a specific logic in other context to enable next step
    }
  }, [step]);

  const store = useMemo(
    () => ({
      state: { step, canGoNext },
      gotoStep: setStep,
      goBack,
      goForward,
      simplotOauthUrl,
      redirectToSimplotAuthorizeOrgUrl,
      blockStepForward,
      releaseStepForward
    }),
    [simplotOauthUrl, redirectToSimplotAuthorizeOrgUrl, step, canGoNext]
  );

  return (
    <SimplotContext.Provider value={store}>{children}</SimplotContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
